export default "__VITE_ASSET__DYioYu85__"